import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Button from "../../components/button";
import Input from "../../components/input";

const EditModal = ({
  isAddMoreOpen,
  closeAddMoreModal,
  handleAddService,
  selectedApi,
}) => {
  const [newService, setNewService] = useState({
    serviceName: "",
    apiKey: "",
    apiSecret: "",
    serviceType: "",
    additionalData: ""
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setNewService({
      serviceName: selectedApi?.serviceName == null ? '' : selectedApi?.serviceName,
      apiKey: selectedApi?.apiKey == null ? '' : selectedApi?.apiKey,
      apiSecret: selectedApi?.apiSecret == null ? '' : selectedApi?.apiSecret,
      serviceType: selectedApi?.serviceType == null ? '' : selectedApi?.serviceType,
      additionalData: selectedApi?.additionalData == null ? '' : selectedApi?.additionalData
    });
  }, [selectedApi]);

  const validateForm = () => {
    let formErrors = {};
    if (!newService.serviceName.trim())
      formErrors.serviceName = "Service Name is required";
    if (!newService.serviceType)
      formErrors.serviceType = "Service Type is required";
    if (!newService.apiKey.trim()) formErrors.apiKey = "API Key is required";
    if (!newService.apiSecret.trim())
      formErrors.apiSecret = "API Secret is required";

    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const handleEdit = () => {
    if (!validateForm()) return;
    handleAddService(newService, 'edit');
    closeAddMoreModal();
  };

  return (
    <Modal show={isAddMoreOpen} onHide={closeAddMoreModal} centered>
      <Modal.Header closeButton>
        <Modal.Title>Edit Api Service</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form>
          <div className="mb-3">
            <Input
              label="Service Name"
              placeholder="Service Name"
              type="text"
              value={newService.serviceName}
              onChange={(e) =>
                setNewService({ ...newService, serviceName: e.target.value })
              }
              required={true}
            />
            {errors.serviceName && (
              <div className="form-error-message">{errors.serviceName}</div>
            )}
          </div>
          <div className="mb-3">
            <Input
              label="Service Type"
              placeholder="Service Type"
              type="select"
              options={[
                { value: "PAYMENT_GATEWAY", label: "Payment Gateway" },
                { value: "OTP_SERVICE", label: "OTP Service" },
                { value: "MAP_SERVICE", label: "Map Service" },
              ]}
              value={newService.serviceType}
              onChange={(e) =>
                setNewService({ ...newService, serviceType: e.target.value })
              }
              required={true}
            />
            {errors.serviceType && (
              <div className="form-error-message">{errors.serviceType}</div>
            )}
          </div>
          <div className="mb-3">
            <Input
              label="API Key"
              placeholder="API Key"
              type="textarea"
              value={newService.apiKey}
              onChange={(e) =>
                setNewService({ ...newService, apiKey: e.target.value })
              }
              required={true}
            />
            {errors.apiKey && (
              <div className="form-error-message">{errors.apiKey}</div>
            )}
          </div>
          <div className="mb-3">
            <Input
              label="API Secret"
              placeholder="API Secret"
              type="textarea"
              value={newService.apiSecret}
              onChange={(e) =>
                setNewService({ ...newService, apiSecret: e.target.value })
              }
              required={true}
            />
            {errors.apiSecret && (
              <div className="form-error-message">{errors.apiSecret}</div>
            )}
          </div>
          <div className="mb-3">
            <Input
              label="API Webhook Secret"
              placeholder="API Webhook Secret"
              type="textarea"
              value={newService.additionalData}
              onChange={(e) =>
                setNewService({ ...newService, additionalData: e.target.value })
              }
            />
            {errors.additionalData && (
              <div className="form-error-message">{errors.additionalData}</div>
            )}
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        <Button text="Edit Service" callBack={handleEdit} />
      </Modal.Footer>
    </Modal>
  );
};

export default EditModal;
